import {BaseService} from "./BaseService";
import {Printer} from "../entities/Printer";
import {HttpHandlerService} from "./HttpHandlerService";
import { StateService } from "@uirouter/angularjs";

export class TokenService extends HttpHandlerService{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q,$state);
    }

    Logout() {
        return this.usePostHandler('token', 'logout', {});
    }
    getUsername(): ng.IPromise<string> {
        return this.useGetHandler('token', "username", {});
    }

}
